import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { EoBreadcrumbService, IBreadcrumb } from './eo-breadcrumb.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'eo-breadcrumb',
  templateUrl: './eo-breadcrumb.component.html',
  styleUrls: ['./eo-breadcrumb.component.scss'],
})
export class EoBreadcrumbComponent implements OnInit {
  subsriptions: Subscription[] = [];
  isHome = false;
  items: MenuItem[] = [];
  defaultItem?: MenuItem;
  @Input() defaultPage = '';
  breadcrumbSegments$ = this.breadcrumbService.breadcrumbSegments$;

  constructor(
    private breadcrumbService: EoBreadcrumbService,
    private router: Router
  ) {}

  ngOnInit() {
    this.subsriptions = [this.getBreadcrumbSub()];
    this.setDefaultItem();
  }

  onBreadcrumbChange(segments: IBreadcrumb[]) {
    this.items = [];
    segments.forEach(async (segment) => {
      const item = await this.getMenuItem(segment);
      if (!item) return;
      this.items = [...this.items, item];
    });
  }

  onBreadcrumbClick(item: IBreadcrumb): void {
    this.breadcrumbService.popUntil(item.id);
  }

  getBreadcrumbSub(): Subscription {
    return this.breadcrumbSegments$.subscribe((segments) => {
      this.onBreadcrumbChange(segments);
    });
  }

  async getMenuItem(segment: IBreadcrumb): Promise<MenuItem | null> {
    if (segment?.route === `/${this.defaultPage}`) {
      this.isHome = true;
      return null;
    } else {
      this.isHome = false;
    }

    const item: MenuItem = segment;
    return item;
  }

  async setDefaultItem() {
    this.defaultItem = {
      icon: 'pi pi-home text-2xl',
      command: () => {
        this.breadcrumbService.clear();
        this.router.navigate([this.defaultPage]);
      },
    };
  }
}
